import { ServiceScheduleItemCaseType } from '../../../graphql/graphql';
import { ServiceScheduleEventCaseType } from '../../Workplace/Interfaces/ServiceScheduleEvent.interface';

// HELPER FOR PREPARE LIST OF CASETYPES AS PART OF EVENT DATA
export const prepareServiceScheduleCaseTypesForEvent = (
	serviceScheduleItemCaseTypes: ServiceScheduleItemCaseType[],
): ServiceScheduleEventCaseType[] => {
	const caseTypes: ServiceScheduleEventCaseType[] = [];

	serviceScheduleItemCaseTypes?.forEach(serviceScheduleItemCaseType => {
		const value = serviceScheduleItemCaseType.workplaceCaseType?.id;
		const label =
			serviceScheduleItemCaseType.workplaceCaseType?.caseType?.label;
		if (value && label) {
			caseTypes.push({
				value,
				label,
				eventInterval:
					serviceScheduleItemCaseType.workplaceCaseType?.caseType
						?.eventInterval ?? undefined,
			});
		}
	});

	return caseTypes;
};
